/* Strap checker bootloader — extracted from sections/main-product.liquid (Sep 2026).
   32KB of identical script inlined into every product page that carries the block.
   The two Liquid values it needed (section id, modal id) now come from the inline
   [data-mgb-strap-checker-config] JSON beside it, so the rest caches as an asset.
   Lazy-boot behaviour is unchanged: the heavy init still waits for a click, focus,
   requestIdleCallback or the 4s timeout. */
/* Strap-checker lazy bootloader.
   The heavy init() (search wiring, API calls, result rendering) only
   runs after one of: user clicks/focuses the card, requestIdleCallback
   fires when the main thread is free, or 4s timeout — whichever comes
   first. This keeps the script out of the critical TTI path. */
(function () {
  var cfgEl = document.querySelector('[data-mgb-strap-checker-config]');
  var cfg = cfgEl ? JSON.parse(cfgEl.textContent) : null;
  if (!cfg) return;
  var SECTION_ID = cfg.sectionId;
  var MODAL_ID = cfg.modalId;
  var booted = false;

  function boot() {
    if (booted) return;
    booted = true;
    initStrapChecker();
  }

  // Open/close delegate bound immediately (before the heavy
  // init boots) so external openers — e.g. the "What size do I
  // need?" link next to the Lug Width option — work on first
  // click. Opening also triggers boot() so the search wires up.
  if (!window.__mgbStrapCheckerBound) {
    window.__mgbStrapCheckerBound = true;
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-mgb-strap-checker-open]');
      if (opener) {
        boot();
        var id = opener.getAttribute('data-mgb-strap-checker-open');
        var modal = document.getElementById(id);
        if (modal) {
          modal.setAttribute('open', '');
          modal.setAttribute('aria-hidden', 'false');
          document.documentElement.style.overflow = 'hidden';
          var inp = modal.querySelector('[data-mgb-strap-checker-search]');
          if (inp) setTimeout(function () { inp.focus(); }, 50);
        }
        return;
      }
      var closer = e.target.closest('[data-mgb-strap-checker-close]');
      if (closer) {
        var m = closer.closest('.mgb-strap-checker-modal');
        if (m) {
          m.removeAttribute('open');
          m.setAttribute('aria-hidden', 'true');
          document.documentElement.style.overflow = '';
        }
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.mgb-strap-checker-modal[open]').forEach(function (m) {
        m.removeAttribute('open');
        m.setAttribute('aria-hidden', 'true');
      });
      document.documentElement.style.overflow = '';
    });
  }

  function bindBootTriggers() {
    var card = document.querySelector('[data-mgb-strap-checker][data-section-id="' + SECTION_ID + '"]');
    var modal = document.getElementById(MODAL_ID);
    if (!card || !modal) return;
    // Boot when the user interacts with anything related
    var triggers = [
      card,
      modal.querySelector('[data-mgb-strap-checker-search]'),
      card.querySelector('[data-mgb-strap-checker-open]')
    ].filter(Boolean);
    ['click', 'focusin', 'pointerenter', 'touchstart'].forEach(function (evt) {
      triggers.forEach(function (t) {
        t.addEventListener(evt, boot, { once: true, passive: true });
      });
    });
  }

  function initStrapChecker() {
    var KEY = 'mgb_watch_fit_v7_cf';
    var DRAFT_KEY = 'mgb_watch_fit_v7_cf_draft_' + SECTION_ID;
    var MIN_CHARS = 2;
    var PAGE_SIZE = 12;
    var FETCH_LIMIT = 100;
    var DEBOUNCE_MS = 250;

    function $(sel, root) { return (root || document).querySelector(sel); }
    function safeParse(s) { try { return JSON.parse(s); } catch (e) { return null; } }
    function clearChildren(el) { if (!el) return; while (el.firstChild) el.removeChild(el.firstChild); }
    function setVisible(el, show) { if (!el) return; if (show) el.removeAttribute('hidden'); else el.setAttribute('hidden', 'hidden'); }
    function normKey(s) { return String(s || '').trim().toLowerCase(); }
    function normaliseText(s) { return String(s || '').toLowerCase().trim(); }
    function save(d) {
      try { localStorage.setItem(KEY, JSON.stringify(d)); } catch (e) {}
      // Tells watch-fit-highlight to re-mark the Lug Width
      // dropdown without waiting for a page load.
      try { document.dispatchEvent(new CustomEvent('mgb:watch-fit-change', { detail: d })); } catch (e) {}
    }
    function loadSaved() { return safeParse(localStorage.getItem(KEY)); }
    function saveDraft(v) { try { sessionStorage.setItem(DRAFT_KEY, String(v || '')); } catch (e) {} }
    function loadDraft() { try { return String(sessionStorage.getItem(DRAFT_KEY) || ''); } catch (e) { return ''; } }
    function clearDraft() { try { sessionStorage.removeItem(DRAFT_KEY); } catch (e) {} }
    function getReferenceFromItem(item) {
      var r = (item && (item.reference ?? item.ref ?? item.Reference ?? item.watch_reference)) ?? null;
      return (r === null || r === undefined) ? '' : String(r).trim();
    }
    function getLugWidthFromItem(item) {
      var lw = (item && (item.lugWidth ?? item.lug_width ?? item.lug_width_mm ?? item.lugWidthMm)) ?? null;
      if (typeof lw === 'string') lw = lw.replace(/mm/i, '').trim();
      return lw;
    }
    function coerceLugWidth(val) {
      if (val === null || val === undefined) return null;
      if (typeof val === 'string') return val.replace(/mm/i, '').trim();
      return val;
    }
    function buildShopUrl(lw) {
      var s = (lw !== undefined && lw !== null) ? String(lw).trim() : '';
      if (s) return '/collections/' + s + 'mm-watch-straps';
      return '/search?type=product&q=' + encodeURIComponent('watch strap');
    }
    function formatSelection(sel) {
      if (!sel) return '';
      var b = String(sel.brand || '').trim();
      var m = String(sel.model || '').trim();
      var r = String(sel.reference || '').trim();
      if (b && m && r) return b + ' ' + m + ' – ' + r;
      if (r) return r;
      if (b && m) return b + ' ' + m;
      return b || m || '';
    }
    function normaliseFromApi(item) {
      if (!item || typeof item !== 'object') return null;
      var brand = String(item.brand || '').trim();
      var model = String(item.model || '').trim();
      var reference = getReferenceFromItem(item) || String(item.unique_id || '').trim();
      var lwRaw = getLugWidthFromItem(item);
      var lugWidth = (lwRaw !== undefined && lwRaw !== null) ? String(lwRaw).replace(/mm/i, '').trim() : '';
      if (!reference) return null;
      return { brand: brand, model: model, reference: reference, lugWidth: lugWidth };
    }
    function extractResults(json) {
      if (!json) return [];
      if (Array.isArray(json)) return json;
      if (Array.isArray(json.results)) return json.results;
      if (json.results && Array.isArray(json.results.items)) return json.results.items;
      if (Array.isArray(json.items)) return json.items;
      if (Array.isArray(json.data)) return json.data;
      if (json.data && Array.isArray(json.data.results)) return json.data.results;
      return [];
    }

    var card = document.querySelector('[data-mgb-strap-checker][data-section-id="' + SECTION_ID + '"]');
    var modal = document.getElementById(MODAL_ID);
    if (!card || !modal) return;
    if (card.getAttribute('data-init') === 'true') return;
    card.setAttribute('data-init', 'true');

    var input = $('[data-mgb-strap-checker-search]', modal);
    var resultsEl = $('[data-mgb-strap-checker-results]', modal);
    var modalStatusEl = $('[data-mgb-strap-checker-modal-status]', modal);
    var modalStatusIcon = $('[data-mgb-strap-checker-modal-status-icon]', modal);
    var modalStatusText = $('[data-mgb-strap-checker-modal-status-text]', modal);
    var cardStatusEl = $('[data-mgb-strap-checker-card-status]', card);
    var cardStatusIcon = $('[data-mgb-strap-checker-card-status-icon]', card);
    var cardStatusText = $('[data-mgb-strap-checker-card-status-text]', card);
    if (!input || !resultsEl) return;

    var productCfg = { strapEndType: '', curvedFitmentUniqueIds: [] };
    try {
      var pcEl = $('[data-mgb-strap-checker-product-config]', card);
      if (pcEl) {
        var pc = safeParse(pcEl.textContent || '{}');
        if (pc) {
          productCfg.strapEndType = pc.strapEndType || '';
          productCfg.curvedFitmentUniqueIds = Array.isArray(pc.curvedFitmentUniqueIds) ? pc.curvedFitmentUniqueIds : (pc.curvedFitmentUniqueIds ? [pc.curvedFitmentUniqueIds] : []);
        }
      }
    } catch (e) {}

    var endpoint = '';
    try {
      var scEl = $('[data-mgb-strap-checker-search-config]', card);
      if (scEl) {
        var sc = safeParse(scEl.textContent || '{}');
        if (sc) endpoint = String(sc.endpoint || '').trim();
      }
    } catch (e) {}

    function isCurved() {
      var t = normKey(productCfg.strapEndType);
      return t.indexOf('curved-end') > -1 || t.indexOf('curved end') > -1;
    }
    function allowedRefs() {
      return (productCfg.curvedFitmentUniqueIds || []).map(function (x) { return String(x || '').trim(); }).filter(function (x) { return x !== ''; });
    }
    function appendShopAllLink(textEl, lwStr) {
      if (!textEl || !lwStr) return;
      var cta = document.createElement('a');
      cta.className = 'mgb-strap-checker__shop-link';
      cta.href = buildShopUrl(lwStr);
      cta.textContent = 'Shop all ' + lwStr + 'mm watch straps →';
      textEl.appendChild(cta);
    }
    function renderStatusInto(targetEl, iconEl, textEl, data) {
      if (!targetEl) return;
      if (!data) { setVisible(targetEl, false); return; }
      var brand = String(data.brand || '').trim();
      var model = String(data.model || '').trim();
      var ref = String(data.reference || '').trim();
      var lwStr = (data.lugWidth !== undefined && data.lugWidth !== null && String(data.lugWidth).trim() !== '') ? String(data.lugWidth).trim() : '';
      var curved = isCurved();
      var ok = true;
      if (curved) {
        var allowed = allowedRefs();
        ok = (ref && allowed.indexOf(ref) > -1);
      }
      targetEl.classList.remove('is-success', 'is-error');
      if (iconEl) clearChildren(iconEl);
      if (textEl) clearChildren(textEl);
      if (ok) {
        targetEl.classList.add('is-success');
        if (iconEl) iconEl.textContent = '✓';
        if (textEl) {
          var msg = document.createElement('span');
          msg.className = 'mgb-strap-checker__status-line';
          msg.appendChild(document.createTextNode(lwStr + 'mm Lug Width selected for your ' + brand + ' ' + model + (ref ? ' – ' + ref : '')));
          textEl.appendChild(msg);
          appendShopAllLink(textEl, lwStr);
        }
      } else {
        targetEl.classList.add('is-error');
        if (iconEl) iconEl.textContent = '✗';
        if (textEl) {
          var errMsg = document.createElement('span');
          errMsg.className = 'mgb-strap-checker__status-line';
          errMsg.appendChild(document.createTextNode('This strap does not fit your ' + brand + ' ' + model + (ref ? ' (' + ref + ')' : '') + '.'));
          textEl.appendChild(errMsg);
          appendShopAllLink(textEl, lwStr);
        }
      }
      setVisible(targetEl, true);
    }
    function renderCardStatus(d) { renderStatusInto(cardStatusEl, cardStatusIcon, cardStatusText, d); }
    function renderModalStatus(d) { renderStatusInto(modalStatusEl, modalStatusIcon, modalStatusText, d); }
    function openResults() { resultsEl.removeAttribute('hidden'); input.setAttribute('aria-expanded', 'true'); }
    function hideResults() { clearChildren(resultsEl); resultsEl.setAttribute('hidden', 'hidden'); input.setAttribute('aria-expanded', 'false'); }
    function renderInfoRow(text) {
      clearChildren(resultsEl);
      var li = document.createElement('li');
      li.className = 'mgb-strap-checker-modal__result mgb-strap-checker-modal__result--info';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mgb-strap-checker-modal__result-btn';
      btn.disabled = true;
      btn.textContent = text;
      li.appendChild(btn);
      resultsEl.appendChild(li);
      openResults();
    }

    var activeController = null;
    var timer = null;
    var lastQuery = '';
    var lastItems = [];

    function apiSearch(qRaw) {
      var q = String(qRaw || '').trim();
      if (q.length < MIN_CHARS) return Promise.resolve({ items: [], error: null });
      if (!endpoint) return Promise.resolve({ items: [], error: { message: 'Missing endpoint' } });
      if (activeController && typeof activeController.abort === 'function') {
        try { activeController.abort(); } catch (e) {}
      }
      activeController = (window.AbortController ? new AbortController() : null);
      var url = endpoint + '?q=' + encodeURIComponent(q) + '&limit=' + encodeURIComponent(String(FETCH_LIMIT));
      var opts = activeController ? { signal: activeController.signal, headers: { 'Accept': 'application/json' } } : { headers: { 'Accept': 'application/json' } };
      return fetch(url, opts).then(function (res) {
        var status = res.status, ok = res.ok;
        return res.text().then(function (txt) {
          var json = safeParse(txt);
          if (!ok) return { items: [], error: { status: status, message: 'HTTP ' + status } };
          if (!json) return { items: [], error: { status: status, message: 'Invalid JSON' } };
          return { items: extractResults(json), error: null };
        });
      }).catch(function (e) {
        return { items: [], error: { message: (e && e.message) ? e.message : 'Network error' } };
      });
    }

    var allGroups = [];
    var currentPage = 0;

    function groupResults(items) {
      var groups = {}, order = [];
      (items || []).forEach(function (raw) {
        var item = normaliseFromApi(raw);
        if (!item) return;
        var brand = (item.brand || '').trim();
        var model = (item.model || '').trim();
        var lug = (item.lugWidth || '').toString().trim();
        var key = brand + '||' + model + '||' + lug;
        if (!groups[key]) {
          groups[key] = { brand: brand, model: model, lugWidth: lug, references: [] };
          order.push(key);
        }
        var ref = (item.reference || '').trim();
        if (ref && groups[key].references.indexOf(ref) === -1) {
          groups[key].references.push(ref);
        }
      });
      return order.map(function (k) { return groups[k]; });
    }

    function selectFit(brand, model, reference, lugWidth) {
      var selected = { brand: brand, model: model, reference: reference, lugWidth: lugWidth };
      save(selected);
      clearDraft();
      input.value = formatSelection(selected);
      hideResults();
      renderModalStatus(selected);
      renderCardStatus(selected);
    }

    function renderGroup(group) {
      var li = document.createElement('li');
      li.className = 'mgb-strap-checker-modal__result';
      li.setAttribute('role', 'option');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mgb-strap-checker-modal__result-btn';
      var thumb = document.createElement('span');
      thumb.className = 'mgb-strap-checker-modal__thumb';
      thumb.setAttribute('aria-hidden', 'true');
      var name = document.createElement('span');
      name.className = 'mgb-strap-checker-modal__name';
      if (group.brand) {
        var b = document.createElement('span');
        b.className = 'mgb-strap-checker-modal__brand';
        b.textContent = group.brand;
        name.appendChild(b);
      }
      var m = document.createElement('span');
      m.className = 'mgb-strap-checker-modal__model';
      m.textContent = group.model || (group.references[0] || '');
      name.appendChild(m);
      if (group.references.length === 1) {
        var refEl = document.createElement('span');
        refEl.className = 'mgb-strap-checker-modal__ref';
        refEl.textContent = 'Ref: ' + group.references[0];
        name.appendChild(refEl);
      } else if (group.references.length > 1) {
        var refCount = document.createElement('span');
        refCount.className = 'mgb-strap-checker-modal__ref-count';
        refCount.textContent = group.references.length + ' references — choose one';
        name.appendChild(refCount);
      }
      var lug = document.createElement('span');
      lug.className = 'mgb-strap-checker-modal__lug';
      if (group.lugWidth) {
        lug.appendChild(document.createTextNode('Lug width'));
        var lwStrong = document.createElement('strong');
        lwStrong.textContent = group.lugWidth + 'mm';
        lug.appendChild(lwStrong);
      }
      var pill = document.createElement('span');
      pill.className = 'mgb-strap-checker-modal__pill';
      var pillOk = true;
      if (isCurved()) {
        var allowed = allowedRefs();
        pillOk = group.references.some(function (r) { return allowed.indexOf(r) > -1; });
      }
      if (pillOk) { pill.textContent = 'Fits'; }
      else {
        pill.classList.add('mgb-strap-checker-modal__pill--warn');
        pill.textContent = (group.lugWidth ? group.lugWidth + 'mm only' : 'Check fit');
      }
      btn.appendChild(thumb);
      btn.appendChild(name);
      if (group.lugWidth) btn.appendChild(lug);
      btn.appendChild(pill);

      if (group.references.length <= 1) {
        btn.addEventListener('click', function (e) {
          if (e) e.stopPropagation();
          selectFit(group.brand, group.model, group.references[0] || '', group.lugWidth);
        });
        li.appendChild(btn);
      } else {
        var caret = document.createElement('span');
        caret.className = 'mgb-strap-checker-modal__caret';
        caret.setAttribute('aria-hidden', 'true');
        caret.textContent = '▾';
        btn.appendChild(caret);
        var refList = document.createElement('ul');
        refList.className = 'mgb-strap-checker-modal__ref-list';
        refList.hidden = true;
        refList.setAttribute('role', 'listbox');
        group.references.forEach(function (ref) {
          var refLi = document.createElement('li');
          refLi.className = 'mgb-strap-checker-modal__ref-item';
          refLi.setAttribute('role', 'option');
          var refBtn = document.createElement('button');
          refBtn.type = 'button';
          refBtn.className = 'mgb-strap-checker-modal__ref-item-btn';
          refBtn.textContent = ref;
          refBtn.addEventListener('click', function (e) {
            if (e) e.stopPropagation();
            selectFit(group.brand, group.model, ref, group.lugWidth);
          });
          refLi.appendChild(refBtn);
          refList.appendChild(refLi);
        });
        btn.setAttribute('aria-expanded', 'false');
        btn.addEventListener('click', function (e) {
          if (e) e.stopPropagation();
          var expanded = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          refList.hidden = expanded;
          caret.classList.toggle('is-open', !expanded);
        });
        li.appendChild(btn);
        li.appendChild(refList);
      }
      resultsEl.appendChild(li);
    }

    function renderNext() {
      var li = document.createElement('li');
      li.className = 'mgb-strap-checker-modal__next';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mgb-strap-checker-modal__next-btn';
      var remaining = allGroups.length - (currentPage + 1) * PAGE_SIZE;
      var nextCount = Math.min(remaining, PAGE_SIZE);
      btn.textContent = 'Next ' + nextCount + (nextCount === 1 ? ' watch' : ' watches');
      btn.addEventListener('click', function (e) {
        if (e) e.stopPropagation();
        currentPage++;
        renderPage();
      });
      li.appendChild(btn);
      resultsEl.appendChild(li);
    }

    function renderPage() {
      clearChildren(resultsEl);
      var start = currentPage * PAGE_SIZE;
      var end = Math.min(start + PAGE_SIZE, allGroups.length);
      for (var i = start; i < end; i++) renderGroup(allGroups[i]);
      if (end < allGroups.length) renderNext();
      openResults();
    }

    function showResults(items) {
      allGroups = groupResults(items);
      currentPage = 0;
      if (!allGroups.length) {
        clearChildren(resultsEl);
        renderInfoRow('No matches found.');
        return;
      }
      renderPage();
    }

    function debounce(fn, wait) {
      return function () {
        var args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () { fn.apply(null, args); }, wait);
      };
    }

    function revalidateSaved(saved) {
      if (!saved) return Promise.resolve(null);
      var ref = String(saved.reference || '').trim();
      if (!ref) return Promise.resolve(null);
      return apiSearch(ref).then(function (res) {
        var items = (res && res.items) ? res.items : [];
        var exact = null;
        for (var i = 0; i < items.length; i++) {
          var it = normaliseFromApi(items[i]);
          if (it && String(it.reference || '').trim() === ref) { exact = it; break; }
        }
        var best = exact || (items.length ? normaliseFromApi(items[0]) : null);
        if (!best) return null;
        return {
          brand: String(best.brand || saved.brand || '').trim(),
          model: String(best.model || saved.model || '').trim(),
          lugWidth: coerceLugWidth(best.lugWidth),
          reference: String(best.reference || ref).trim()
        };
      });
    }

    function handleSearch() {
      setVisible(modalStatusEl, false);
      var q = (input.value || '').trim();
      saveDraft(q);
      if (q.length < MIN_CHARS) { hideResults(); return; }
      renderInfoRow('Searching…');
      apiSearch(q).then(function (res) {
        var items = (res && res.items) ? res.items : [];
        lastQuery = q;
        lastItems = items;
        if (res && res.error) { renderInfoRow('Search error. Try again.'); return; }
        showResults(items);
      });
    }

    var draft = loadDraft();
    if (draft && !input.value) input.value = draft;
    var saved = loadSaved();
    if (saved) {
      renderCardStatus(saved);
      revalidateSaved(saved).then(function (refreshed) {
        if (refreshed) {
          save(refreshed);
          input.value = formatSelection(refreshed);
          renderCardStatus(refreshed);
        }
      });
    }

    input.addEventListener('input', debounce(handleSearch, DEBOUNCE_MS));
    input.addEventListener('focus', function () {
      var q = (input.value || '').trim();
      if (q.length < MIN_CHARS) return;
      if (lastQuery && normaliseText(lastQuery) === normaliseText(q) && lastItems && lastItems.length) {
        showResults(lastItems);
        return;
      }
      handleSearch();
    });
  }

  // (Open/close + Escape handlers are bound eagerly above in
  // the bootloader so external openers work before boot.)

  // Lazy boot dispatcher: interaction OR idle OR 4s timeout
  function scheduleBoot() {
    bindBootTriggers();
    if ('requestIdleCallback' in window) {
      requestIdleCallback(boot, { timeout: 4000 });
    } else {
      setTimeout(boot, 2500);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleBoot);
  } else {
    scheduleBoot();
  }
})();
